/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
        // JavaScript to be fired on all pages
      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
      },
      sendMail: function($page,email, name){
    $name = $_POST["name"];
    $to = $_POST["email"];
    $message="Votre ami "+$name+"vous à envoyer cette formule. Pour plus d'info, visiter notre site web.";
        $subject="Le Forum: Formule";
        
    /*
     * Set result to true if value1 equals value2.  The value2 must be a constant value?
     * opcode number: 48
     */

    switch ($page){

        // LE SALE FIN
      case 'les-bouchees-chaudes-froides':
        $attachments = ('/uploads/sites/3/2016/12/1-Les-Bouchées-Chaudes-Froides.pdf');
        break;
      case 'les-bouchees-traditionnelles':
        $attachments = ('/uploads/sites/3/2016/12/2-Les-Bouchées-Tradionnelles.pdf');
        break;

      case 'les-verrines':
        $attachments = ('/uploads/sites/3/2016/12/3-Les-Verrines.pdf');
        break;

      case 'les-brochettes':
        $attachments = ('/uploads/sites/3/2016/12/4-Les-Brochettes.pdf');
        break;
        //LES DELICES SUCREES
      case 'patisseries-tunisiennes':
        $attachments = ('/uploads/sites/3/2016/12/1-Patisseries-Tunisiennes.pdf');
        break;

      case 'traditions-revisitees':
        $attachments = ('/uploads/sites/3/2016/12/2-La-Tradition-Revisitée.pdf');
        break;

      case 'les-bouchees-sucrees':
        $attachments = ('/uploads/sites/3/2016/12/3-Les-Bouchées-Sucrées.pdf');
        break;

      case 'les-gateaux-de-ceremonie':
        $attachments = ('/uploads/sites/3/2016/12/4-Les-Gâteaux-de-Cérémonie.pdf');
        break;


      case 'elite':
        $attachments = ('/uploads/sites/3/2016/12/2-ELITE.pdf');
        break;
      case 'jet-set':
        $attachments = ('/uploads/sites/3/2016/12/4-JET-SET.pdf');
        break;

      case 'v-i-p':
        $attachments = ('/uploads/sites/3/2016/12/3-VIP.pdf');
        break;

      case 'top':
        $attachments = ('/uploads/sites/3/2016/12/1-TOP.pdf');
        break;

      case 'palace':
        $attachments = ('/uploads/sites/3/2016/12/4-PALACE.pdf');
        break;

      case 'quatre-etoiles':
        $attachments = ('/uploads/sites/3/2016/12/2-4-ETOILES.pdf');
        break;

      case 'cinq-etoiles':
        $attachments = ('/uploads/sites/3/2016/12/3-5-ETOILES.pdf');
        break;

      case 'star-buffet':
        $attachments = ('/uploads/sites/3/2016/12/1-STAR-BUFFET.pdf');
        break;


      case 'entrees':
        $attachments = ('/uploads/sites/3/2016/12/1-ENTREE.pdf');
        break;
      case 'salades':
        $attachments = ('/uploads/sites/3/2016/12/2-SALADE.pdf');
        break;

      case 'pates':
        $attachments = ('/uploads/sites/3/2016/12/3-PATES.pdf');
        break;

      case 'garnitures':
        $attachments = ('/uploads/sites/3/2016/12/4-GARNITURE.pdf');
        break;

      case 'plat-principal':
        $attachments = ('/uploads/sites/3/2016/12/5-PLAT-PRINCIPAL.pdf');
        break;

      case 'desserts':
        $attachments = ('/uploads/sites/3/2016/12/6-DESSERT.pdf');
        break;





      case 'cinq-etoiles':
        $attachments = (WP_CONTENT_DIR +'/uploads/sites/3/2016/12/3-5-ETOILES.pdf');
        break;

      case 'star-buffet':
        $attachments = (WP_CONTENT_DIR +'/uploads/sites/3/2016/12/1-STAR-BUFFET.pdf');
        break;


    }

    wpMail( $to, $subject, $message, $headers, $attachments );

  }

},
    // Home page
    'home': {
        init: function() {
          // JavaScript to be fired on the home page
          console.log('hello front');
          initializeBanner();
          initializeCarousel();


        }
      },
    // About us page, note the change from about-us to about_us.
    'about_us': {
      init: function() {
        // JavaScript to be fired on the about us page
      }
    },
    'selecteur-de-date':{
      init:function(){
        selecteurDate();
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };


  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
